import React from "react";
import { ArrowLeft } from "lucide-react";
import LedgerTab from "@/components/nds/windows/finance/LedgerTab";
import BalancesTab from "@/components/nds/windows/finance/BalancesTab";
import { OpenResidentButton } from "@/components/nds/OpenResidentButton";
import { CardDeck, CardsBack, useCardTabs } from "@/components/nds/TabCards";

const TABS = [
  { id: "ledger", label: "Ledger", Tab: LedgerTab, tone: "data", desc: "Every money line for this resident" },
  { id: "balances", label: "Balances", Tab: BalancesTab, tone: "financial", desc: "Payroll, rent, PACT Fee, line of credit, cash in hand, savings and NCN" },
];

export default function FinLedgerDetail({ resident, onBack, highlight }) {
  const ct = useCardTabs("ledger");
  React.useEffect(() => { if (highlight && ct.deck) ct.open("ledger"); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const tab = ct.tab;
  const setTab = ct.open;
  const { Tab, label } = TABS.find((t) => t.id === tab);
  return (
    <div data-testid="fin-ledger-detail" className="flex flex-col h-full">
      <div className="px-5 pt-4 space-y-3 border-b border-white/10">
        <button type="button" onClick={onBack} data-testid="fin-ledger-back" className="inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.2em] uppercase text-nex-gold">
          <ArrowLeft className="h-3 w-3" /> All residents
        </button>
        <div className="flex items-center gap-3"><h3 data-testid="fin-ledger-detail-name" className="text-lg text-nex-silver font-semibold">{resident.first_name} {resident.last_name}</h3><OpenResidentButton residentId={resident.id} name={`${resident.first_name} ${resident.last_name}`} /></div>
        {ct.compact ? <div className="pb-3" /> : <div className="flex gap-4">
          {TABS.map((t) => (
            <button key={t.id} type="button" onClick={() => setTab(t.id)} data-testid={`fin-ledger-tab-${t.id}`} aria-pressed={tab === t.id}
              className={`pb-2 font-mono text-[10px] tracking-[0.2em] uppercase border-b-2 transition-colors ${tab === t.id ? "border-nex-gold text-nex-gold" : "border-transparent text-nex-muted hover:text-nex-silver"}`}>
              {t.label}
            </button>
          ))}
        </div>}
      </div>
      <div ref={ct.ref} className="flex-1 overflow-y-auto">
        {ct.deck ? <div className="p-5"><CardDeck testid="fin-ledger-cards" items={TABS} onOpen={setTab} /></div>
          : <>{ct.compact && <CardsBack testid="fin-ledger-cards-back" className="mx-5 mt-4" label={label} onClick={ct.close} />}<Tab resident={resident} highlight={highlight} /></>}
      </div>
    </div>
  );
}
